import request from "./request.js";

export default {
  // 登录
  addAnswer: (data) => {
    return request({
      url: "api/admin/answer/batchAddAnswers",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  updateAnswer: (data) => {
    return request({
      url: "api/admin/answer/updateAnswer",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
};
